import { StockIndicator } from "~/src/components/StockIndicator"

export type KitItem = {
  /**
   * Title (i.e., `display_name`) of the variant.
   */
  title: string
  /**
   * Amount of items in stock. Set to `null` if the item is always in stock (i.e., not required).
   */
  quantity?: number
  /**
   * Whether or not the item is always in stock (i.e., not required).
   */
  inventoryRequired: boolean
}

export type KitInventoryTableProps = {
  /**
   * List of variant items.
   */
  items: KitItem[]
}

export function KitInventoryTable(props: KitInventoryTableProps) {
  const { items } = props

  return (
    <div className="w-full @container">
      <h1 className="mb-2 text-sm font-medium text-gray-500">In this kit:</h1>
      <table className="w-full border-t border-t-gray-200">
        <tbody>
          {items.map((item) => {
            const { title, inventoryRequired } = item
            const quantity = inventoryRequired ? item.quantity : Infinity

            return (
              <tr
                key={title}
                className="flex flex-col border-b border-b-gray-200 py-2 text-sm text-gray-500 @sm:table-row @sm:py-0 @sm:[&>td]:py-2"
              >
                <td>{title}</td>

                <td className="w-0">
                  <div className="flex items-end">
                    {quantity == null ? <></> : <StockIndicator className="ml-auto" hideDot quantity={quantity} />}
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
